import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=6c65a562&scoped=true&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=6c65a562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65a562",
  null
  
)

export default component.exports